var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClothesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e4ad1f8a-cb8e-4ed1-aea3-d275c128e7f6",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.56 139.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M102.6,30.17c-6.45-5.06-20.24-8.25-20.82-8.38a2,2,0,0,0-2.4,1.5,2.3,2.3,0,0,0,0,.45c0,2.7-5.54,6-12,6s-12-3.3-12-6a2,2,0,0,0-.75-1.57,2,2,0,0,0-1.69-.4c-.59.13-14.37,3.32-20.83,8.39-6.66,5.26-8.56,30.62-8.76,33.49a2,2,0,0,0,1.13,1.93,47.31,47.31,0,0,0,14.89,4.13v42.13a2,2,0,0,0,1.06,1.76c.33.18,8.19,4.24,27,4.24s26.64-4.06,27-4.24a2,2,0,0,0,1.06-1.76V69.71a47.46,47.46,0,0,0,14.89-4.13,2,2,0,0,0,1.13-1.93C111.17,60.78,109.27,35.42,102.6,30.17Z",
    style: {
      fill: "#67c6e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.29,69.79a2,2,0,0,1-2-2v-12a16,16,0,0,0-3.42-10.59,2,2,0,0,1,2.83-2.83,19.6,19.6,0,0,1,4.59,13.42v12A2,2,0,0,1,41.29,69.79Z",
    style: {
      fill: "#1787c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.35,69.79a2,2,0,0,1-2-2v-12a19.54,19.54,0,0,1,4.59-13.43,2,2,0,1,1,2.88,2.78l0,.05a16,16,0,0,0-3.42,10.6v12A2,2,0,0,1,93.35,69.79Z",
    style: {
      fill: "#1787c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.61,22.19A2,2,0,0,0,81,21.77a123.08,123.08,0,0,1-13.64,2,122.74,122.74,0,0,1-13.64-2,2,2,0,0,0-2.38,2c0,6,8.28,10,16,10s16-4,16-10A2,2,0,0,0,82.61,22.19Z",
    style: {
      fill: "#2f72b9"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothesIcon);
export default __webpack_public_path__ + "static/media/clothes-icon.02f6cc415f77f1566fb8425986c60501.svg";
export { ForwardRef as ReactComponent };